<template>
  <div class="common-bg" style="min-height: 100vh; box-sizing: border-box">
    <!-- 顶部用户信息区 -->
    <div class="mine-header">
      <!-- 未登录 -->
      <div v-if="!$store.state.token" class="mine-not-login">
        <div class="mine-not-login-text">
          <span class="mine-not-login-title">登录后可领取收益</span>
          <div class="mine-not-login-btns">
            <span class="mine-not-login-btn mine-not-login-btn-login" @click="showLogin(1)">登录</span>
            <span class="mine-not-login-btn mine-not-login-btn-register" @click="showLogin(0)">注册</span>
          </div>
        </div>
        <img src="/static/newImg/mine/style_7_icon_lh.avif" class="mine-not-login-gift" />
      </div>
      <!-- 已登录 -->
      <template v-else>
      <div class="mine-header-icons">
        <div class="mine-icon-item" @click="$router.push({ path: '/notice', query: { noticeType: '4', from: 'mine' } })">
          <img src="/static/image/iconKefu.png" />
        </div>
        <div class="mine-icon-item mine-icon-msg" @click="$router.push({ path: '/notice', query: { noticeType: '2', from: 'mine' } })">
          <van-icon name="chat-o" color="#fff" size="25" dot />
        </div>
      </div>
      <!-- 用户信息行 -->
      <div class="mine-user-row">
        <div class="mine-avatar-box">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/newImg/mine/img_ntx6.avif'" alt="" />
          <input class="mine-avatar-input" type="file" @change="onchangemd" single accept="image/gif,image/png" />
        </div>
        <div class="mine-user-info">
          <div class="mine-user-top">
            <span class="mine-username">{{ $store.state.userInfo.username }}</span>
            <img src="/static/newImg/index/copy01.png" class="mine-copy-icon" @click="doCopy($store.state.userInfo.username)" />
            <span class="mine-switch-btn" @click="$parent.goNav('/switchAccount')">
              <img src="/static/newImg/mine/style_7_icon_qh.svg" class="mine-qh-icon" />
              切换
            </span>
          </div>
          <div class="mine-user-bottom">
            <span class="mine-id-label">ID:</span>
            <span class="mine-id-text">{{ $store.state.userInfo.id }}</span>
            <img src="/static/newImg/index/copy01.png" class="mine-copy-icon-sm" @click="doCopy($store.state.userInfo.id)" />
          </div>
        </div>
      </div>

      <!-- 余额和操作按钮行 -->
      <div class="mine-bottom-row">
        <div class="mine-balance-wrap">
          <img src="/static/newImg/mine/CNY.avif" class="mine-balance-dot" />
          <span class="mine-balance-num" @click="$parent.goNav('/report?reportCurrent=4')">{{ $store.state.userInfo.balance }}</span>
          <img src="/static/newImg/index/refresh01.png" class="mine-refresh-icon" @click="$parent.getUserInfoShowLoding()" />
        </div>
        <div class="mine-action-btns">
          <div class="mine-action-item" @click="$router.push({ path: '/recharge' })">
            <div class="mine-action-icon-box">
              <img src="/static/newImg/mine/style_7_icon_mid_ck.avif" />
              <span class="mine-action-badge">送2%</span>
            </div>
            <span class="mine-action-label">线下存款</span>
          </div>
          <div class="mine-action-item" @click="$parent.goNav('/recharge')">
            <div class="mine-action-icon-box">
              <img src="/static/newImg/mine/style_7_icon_mid_ck.avif" />
              <span class="mine-action-badge">送2%</span>
            </div>
            <span class="mine-action-label">在线存款</span>
          </div>
          <div class="mine-action-item" @click="$parent.goNav('/withdraw')">
            <img src="/static/newImg/mine/style_7_icon_mid_tx.avif" />
            <span class="mine-action-label">提现</span>
          </div>
        </div>
      </div>
      </template>
    </div>

    <!-- 每日签到 -->
    <div class="mine-checkin-box">
      <div class="mine-checkin-head">
        <div class="mine-checkin-title-wrap">
          <span class="mine-checkin-title">每日签到</span>
          <span class="mine-checkin-subtitle">每天充值玩游戏，好礼享不停</span>
        </div>
        <div class="mine-more-wrap">
          <img src="/static/newImg/mine/qd_img_icon2.avif" class="mine-more-icon" />
          <span class="mine-checkin-more" @click="$parent.goNav('/activity')">更多活动 ></span>
        </div>
      </div>
      <div class="mine-checkin-scroll">
        <div class="mine-checkin-card" :class="{'mine-checkin-card-first': item.status === 'current'}" v-for="(item, idx) in checkinList" :key="idx">
          <div class="mine-checkin-extra" v-if="item.extra_reward * 1 > 0">额外奖励</div>
          <div class="mine-checkin-amount">{{ item.reward }}</div>
          <div class="mine-checkin-img">
            <img src="/static/newImg/mine/qd_style2_img_qdjb1.avif" />
          </div>
          <div class="mine-checkin-label mine-checkin-btn" v-if="item.status === 'current' && checkinInfo && checkinInfo.can_sign * 1 === 1" @click="doCheckin">签到</div>
          <div class="mine-checkin-label mine-checkin-label-claimed" v-else-if="item.status === 'claimed'">已领取</div>
          <div class="mine-checkin-label" v-else>第{{ idx + 1 }}天</div>
        </div>
      </div>
    </div>

    <!-- 绑定钱包横幅 -->
    <!-- <div class="bind-banner">
      <div class="bind-text">
        <img src="/static/newImg/mine/comm_icon_NOlogo2.svg" class="bind-no-logo" />
        <span class="bind-no">绑定NO钱包充提自由+抽</span>
        <span class="bind-amount">88,888.88</span>
        <span class="bind-prize">大奖</span>
      </div>
      <div class="bind-btns">
        <span class="bind-btn">绑定</span>
        <img src="/static/newImg/index/refresh.png" class="bind-refresh" />
      </div>
    </div> -->

    <!-- 快捷功能 -->
    <div class="quick-functions">
      <div class="section-title">快捷功能</div>
      <div class="func-grid">
        <div class="func-item" v-for="(item, idx) in funcList" :key="idx" @click="handleFuncClick(item)">
          <div class="func-icon-wrap">
            <template v-if="idx === 0">
              <div class="lxb-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_lxb.svg" class="lxb-img-pig" />
                <img src="/static/newImg/mine/style_7_icon_lxb1.svg" class="lxb-img-coin" />
              </div>
            </template>
            <template v-else-if="idx === 1">
              <div class="gjj-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_gjj.svg" class="gjj-img-hands" />
                <img src="/static/newImg/mine/style_7_icon_gjj1.svg" class="gjj-img-coin" />
              </div>
            </template>
            <template v-else-if="idx === 2">
              <div class="wdjl-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_zdjl.svg" class="wdjl-img-frame" />
                <img src="/static/newImg/mine/style_7_icon_zdjl1.svg" class="wdjl-img-qr" />
              </div>
            </template>
            <template v-else-if="idx === 3">
              <div class="txgl-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_txgl.svg" class="txgl-img-frame" />
                <img src="/static/newImg/mine/style_7_icon_txgl1.svg" class="txgl-img-detail" />
              </div>
            </template>
            <template v-else-if="idx === 4">
              <div class="zkq-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_zkq.svg" class="zkq-img-star" />
                <img src="/static/newImg/mine/style_7_icon_zkq1.svg" class="zkq-img-percent" />
              </div>
            </template>
            <template v-else-if="idx === 5">
              <div class="vip-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_vip.svg" class="vip-img-hat" />
                <img src="/static/newImg/mine/style_7_icon_vip1.svg" class="vip-img-dots" />
              </div>
            </template>
            <template v-else-if="idx === 6">
              <div class="fxzq-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_fxzq.svg" class="fxzq-img-user" />
                <img src="/static/newImg/mine/style_7_icon_fxzq1.svg" class="fxzq-img-horn" />
              </div>
            </template>
            <template v-else-if="idx === 7">
              <div class="fx-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_fx.svg" class="fx-img-circle" />
                <img src="/static/newImg/mine/style_7_icon_fx1.svg" class="fx-img-lines" />
                <div class="fx-red-dot"></div>
              </div>
            </template>
            <template v-else-if="idx === 8">
              <div class="dfgdb-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_dfgdb.svg" class="dfgdb-img-shield" />
                <img src="/static/newImg/mine/style_7_icon_dfgdb1.svg" class="dfgdb-img-check" />
                <img src="/static/newImg/mine/style_7_icon_dfgdb2.svg" class="dfgdb-img-hands" />
              </div>
            </template>
            <template v-else-if="idx === 9">
              <div class="grzl-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_grzl.svg" class="grzl-img-user" />
                <img src="/static/newImg/mine/style_7_icon_grzl1.svg" class="grzl-img-pencil" />
              </div>
            </template>
            <template v-else-if="idx === 10">
              <div class="aqzx-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_aqzx.svg" class="aqzx-img-shield" />
              </div>
            </template>
            <template v-else-if="idx === 11">
              <div class="yyxz-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_yyxz.svg" class="yyxz-img-e" />
                <img src="/static/newImg/mine/style_7_icon_yyxz1.svg" class="yyxz-img-n" />
              </div>
            </template>
            <template v-else-if="idx === 12">
              <div class="cjwt-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_cjwt.svg" class="cjwt-img-frame" />
                <img src="/static/newImg/mine/style_7_icon_cjwt1.svg" class="cjwt-img-question" />
              </div>
            </template>
            <template v-else-if="idx === 13">
              <div class="yjfk-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_yjfk.svg" class="yjfk-img-frame" />
                <img src="/static/newImg/mine/style_7_icon_yjfk1.svg" class="yjfk-img-detail" />
              </div>
            </template>
            <template v-else-if="idx === 14">
              <div class="dlsb-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_dlsb.svg" class="dlsb-img-computer" />
                <img src="/static/newImg/mine/style_7_icon_dlsb1.svg" class="dlsb-img-frame" />
              </div>
            </template>
            <template v-else-if="idx === 15">
              <div class="gywm-icon-wrap">
                <img src="/static/newImg/mine/style_7_icon_gywm.svg" class="gywm-img-circle" />
                <img src="/static/newImg/mine/style_7_icon_gywm1.svg" class="gywm-img-info" />
              </div>
            </template>
            <template v-else>
              <img :src="item.icon" />
            </template>
            <span class="func-badge" v-if="item.badge">{{ item.badge }}</span>
          </div>
          <span class="func-name" v-if="idx !== 15 && idx !== 8">{{ item.name }}</span>
          <span class="func-name func-name-br" v-else-if="idx === 15">关于新蒲京<br>集团</span>
          <span class="func-name func-name-br" v-else>第三方<br>平台担保</span>
        </div>
        <div class="func-item" @click="$parent.goNav('/switchAccount')" v-if="$store.state.token">
          <div class="func-icon-wrap">
            <div class="qhzh-icon-wrap">
              <img src="/static/newImg/mine/style_7_icon_qhzh.svg" class="qhzh-img-left" />
              <img src="/static/newImg/mine/style_7_icon_qhzh1.svg" class="qhzh-img-right" />
            </div>
          </div>
          <span class="func-name">切换账号</span>
        </div>
        <div class="func-item" @click="$parent.outLogin" v-if="$store.state.token">
          <div class="func-icon-wrap">
            <div class="tc-icon-wrap">
              <img src="/static/newImg/mine/style_7_icon_tc.svg" class="tc-img-frame" />
              <img src="/static/newImg/mine/style_7_icon_tc1.svg" class="tc-img-arrow" />
            </div>
          </div>
          <span class="func-name">退出</span>
        </div>
      </div>
    </div>

    <!-- 语言选择弹窗 -->
    <div class="lang-popup-mask" v-if="showLangPopup" @click="showLangPopup = false">
      <div class="lang-popup-content" @click.stop>
        <div class="lang-popup-title">选择语言</div>
        <div class="lang-popup-item">
          <span>简体中文</span>
          <div class="lang-radio-active">
            <van-icon name="success" color="#000" size="14" />
          </div>
        </div>
        <div class="lang-popup-close" @click="showLangPopup = false">
          <van-icon name="cross" color="#fff" size="24" />
        </div>
      </div>
    </div>

    <!-- 旧代码保留 -->
    <!--
    <div style="padding: 0 18px">
      <div class="mineTop flex-c-end">
        <div class="flex-c-c">
          <div class="kefus" @click="$parent.openKefu()">
            <img src="/static/image/iconKefu.png" />
          </div>
          <div @click="$parent.goNav('/message')">
            <van-icon name="chat-o" color="#fff" size="24" dot />
          </div>
        </div>
      </div>
      <div class="usersg">
        <div class="lesf">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" />
          <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
        </div>
        <div class="center" @click="$parent.goNav('/userInfo')">
          <div class="name">
            {{ $store.state.userInfo.username }}
            <img :src="`/static/style/vip${$store.state.userInfo.vip}.png`" alt="" />
          </div>
          <div class="dat">加入{{ $store.state.appInfo.title }}第{{ $store.state.userInfo.joinday }}天</div>
        </div>
        <img class="rig" @click="$parent.goNav('/userInfo')" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
      </div>
    </div>
    <div class="meys-new">
      <van-row>
        <van-col span="12">
          <div class="meysf">
            <div class="t">钱包余额</div>
            <div class="m">{{ $store.state.userInfo.balance }}</div>
          </div>
        </van-col>
        <van-col span="4">
          <div class="top-m" @click="$parent.goNav('/recharge')">
            <van-badge content="送2%" color="#fe6a93">
              <img src="/static/newImg/icon_cz.avif" alt="" />
              <div class="title">线下存款</div>
            </van-badge>
          </div>
        </van-col>
        <van-col span="4">
          <div class="top-m" @click="$parent.goNav('/recharge')">
            <van-badge content="送2%" color="#fe6a93">
              <img src="/static/newImg/icon_cz.avif" alt="" />
              <div class="title">存款</div>
            </van-badge>
          </div>
        </van-col>
        <van-col span="4">
          <div class="top-m" @click="$parent.goNav('/withdraw')">
            <img src="/static/newImg/icon_tx.avif" alt="" />
            <div class="title">提现</div>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="vip-box" @click="$parent.goNav('/vip')">
      <div class="top flex-c-b">
        <div class="left">
          <div class="t">VIP {{$store.state.userInfo.vip}}<img src="/static/image/right.b9a9c7c64558347505384ad01922580c.png" alt="" /></div>
          <div class="m">晋级奖金<b>10.00</b></div>
        </div>
        <div class="right">
          <img :src="`/static/newImg/vip/icon_vip_${$store.state.userInfo.vip}.avif`" alt="" />
        </div>
      </div>
      <div class="bottom flex-c-b">
        <div class="left">
          <div class="i">晋级VIP需再 <b><span>充值</span> 0.00</b></div>
          <van-progress :percentage="100" :show-pivot="false" color="#DFB372" />
          <div class="s">0.00 / 0.00</div>
        </div>
        <div class="right">
          <div class="i">晋级VIP需再 <b><span>投注</span> 2000.00</b></div>
          <van-progress :percentage="0" :show-pivot="false" color="#DFB372" />
          <div class="s">0.00 / 2000.00</div>
        </div>
      </div>
    </div>
    <div class="uslis">
      <div style="box-sizing: border-box; padding: 0 12px">
        <div style="height: 24px"></div>
        <div class="bosfs-new-box">
          <div class="title">功能中心</div>
          <div class="bosfs-new">
            <van-grid clickable :column-num="4">
              <van-grid-item icon="home-o" text="我的钱包" to="/report?reportCurrent=4">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon1.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="home-o" text="交易记录" to="/transRecord">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon2.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="home-o" text="投注记录" to="/betRecord">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon3.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="home-o" text="返水中心" to="/fanshui">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon4.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="search" text="活动记录" to="/activityRecord">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon5.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="search" text="福利中心" to="/welfare">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon6.png"/>
                </template>
              </van-grid-item>
            </van-grid>
          </div>
          <div class="title">账户安全</div>
          <div class="bosfs-new">
            <van-grid clickable :column-num="4">
              <van-grid-item icon="search" text="账户设置" to="/userCent">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon7.png"/>
                </template>
              </van-grid-item>
            </van-grid>
          </div>
          <div class="title">帮助与支持</div>
          <div class="bosfs-new">
            <van-grid clickable :column-num="4">
              <van-grid-item icon="search" text="合营计划" to="/applyagent">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon8.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="search" text="APP下载" to="/app">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon9.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="search" text="帮助中心" to="/boutBallBet">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon10.png"/>
                </template>
              </van-grid-item>
              <van-grid-item icon="search" text="退出系统" @click="$parent.outLogin">
                <template #icon>
                  <van-image width=".55rem" height=".55rem" fit="contain" src="/static/newImg/mine/mine-icon11.png"/>
                </template>
              </van-grid-item>
            </van-grid>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      activitylistList: [],
      bfNum: 0,
      vipLis: [],
      checkinList: [
        { reward: '6.00', extra_reward: '0.00', status: 'future' },
        { reward: '8.00', extra_reward: '0.00', status: 'future' },
        { reward: '10.00', extra_reward: '0.00', status: 'future' },
        { reward: '12.00', extra_reward: '0.00', status: 'future' },
        { reward: '14.00', extra_reward: '5.00', status: 'future' },
        { reward: '16.00', extra_reward: '0.00', status: 'future' },
        { reward: '18.00', extra_reward: '0.00', status: 'future' },
        { reward: '20.00', extra_reward: '0.00', status: 'future' },
        { reward: '22.00', extra_reward: '0.00', status: 'future' },
        { reward: '24.00', extra_reward: '10.00', status: 'future' },
        { reward: '26.00', extra_reward: '0.00', status: 'future' },
        { reward: '28.00', extra_reward: '0.00', status: 'future' },
        { reward: '30.00', extra_reward: '0.00', status: 'future' },
        { reward: '32.00', extra_reward: '0.00', status: 'future' },
        { reward: '36.00', extra_reward: '15.00', status: 'future' },
      ],
      checkinInfo: null,
      showLangPopup: false,
      funcList: [
        { name: '利息宝', icon: '/static/newImg/mine/mine-icon1.png', badge: '100%', url: '/activity', query: { tab: '6' } },
        { name: '公积金', icon: '/static/newImg/mine/mine-icon2.png', badge: '100%', url: '/activity', query: { tab: '8' } },
        { name: '我的记录', icon: '/static/newImg/mine/mine-icon3.png', url: '/report', query: { reportCurrent: '1' } },
        { name: '提现管理', icon: '/static/newImg/mine/mine-icon4.png', url: '/withdraw', query: { active: '3' } },
        { name: '折扣券', icon: '/static/newImg/mine/mine-icon5.png', url: '/coupon' },
        { name: 'VIP中心', icon: '/static/newImg/mine/mine-icon6.png', url: '/activity', query: { tab: '3' } },
        { name: '分享赚钱', icon: '/static/newImg/mine/mine-icon8.png', url: '/promote' },
        { name: '发现', icon: '/static/newImg/mine/mine-icon9.png', url: '/plazza' },
        { name: '第三方平台担保', icon: '/static/newImg/mine/mine-icon10.png', url: '/claim' },
        { name: '个人资料', icon: '/static/newImg/mine/mine-icon7.png', url: '/setting' },
        { name: '安全中心', icon: '/static/newImg/mine/mine-icon7.png', url: '/security' },
        { name: '选择语言', icon: '/static/newImg/mine/mine-icon7.png', action: 'language' },
        { name: '常见问题', icon: '/static/newImg/mine/mine-icon10.png', url: '/notice', query: { noticeType: '4', from: 'mine' } },
        { name: '有奖反馈', icon: '/static/newImg/mine/mine-icon5.png', url: '/notice', query: { noticeType: '5', from: 'mine' } },
        { name: '登录设备', icon: '/static/newImg/mine/mine-icon7.png', url: '/loginDevice' },
        { name: '关于新蒲京集团', icon: '/static/newImg/mine/mine-icon10.png', url: '/boutBallBetInfo', query: { type: '7' } },
      ],
    };
  },
  created() {
    let that = this;
    that.activitylist();
    that.uservip();
    that.getCheckinInfo();
  },
  mounted() {
    if (!this.$store.state.token) {
      this.$parent.$parent.loginNewShow = true;
    }
  },
  activated() {
    if (!this.$store.state.token) {
      this.$parent.$parent.loginNewShow = true;
    } else {
      this.getCheckinInfo();
    }
  },
  watch: {
    // 未登录状态下在本页通过弹窗登录成功后，补拉签到信息
    '$store.state.token'(newVal, oldVal) {
      if (newVal && !oldVal) {
        this._checkinInfoAt = 0;
        this.getCheckinInfo();
      }
    },
  },
  methods: {
    showLogin(type) {
      this.$parent.$parent.loginDefaultType = type;
      this.$parent.$parent.loginNewShow = true;
    },
    getCheckinInfo() {
      let that = this;
      if (!that.$store.state.token) {
        return;
      }
      // 防止 created + activated 双钩子重复请求
      let now = Date.now();
      if (that._checkinInfoAt && now - that._checkinInfoAt < 500) {
        return;
      }
      that._checkinInfoAt = now;
      that.$apiFun.checkinInfo({}).then(res => {
        if (res.code === 200 && res.data && res.data.days && res.data.days.length) {
          that.checkinInfo = res.data;
          that.checkinList = res.data.days.map(d => ({
            reward: (d.reward * 1).toFixed(2),
            extra_reward: d.extra_reward * 1,
            status: d.status,
          }));
        }
      }).catch(() => {});
    },
    doCheckin() {
      let that = this;
      let info = that.checkinInfo;
      if (!info) {
        return;
      }
      if (info.signed_today * 1 === 1) {
        that.$parent.showTost(0, '今日已签到');
        return;
      }
      if (info.can_sign * 1 !== 1) {
        let msgs = [];
        if (info.recharge_min * 1 > 0 && info.today_recharge * 1 < info.recharge_min * 1) {
          msgs.push('充值满' + info.recharge_min + '元');
        }
        if (info.bet_min * 1 > 0 && info.today_bet * 1 < info.bet_min * 1) {
          msgs.push('投注满' + info.bet_min + '元');
        }
        that.$parent.showTost(0, msgs.length ? '今日' + msgs.join('且') + '后才可签到' : '今日暂不能签到');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun.checkinSign({}).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(res.code === 200 ? 1 : 0, res.message || (res.code === 200 ? '签到成功' : '签到失败'));
        if (res.code === 200) {
          that.getCheckinInfo();
          that.$parent.getUserInfoShowLoding();
        }
      }).catch(() => {
        that.$parent.hideLoading();
      });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.$parent.showTost(1, '复制成功！');
    },
    handleFuncClick(item) {
      if (item.action === 'language') {
        this.showLangPopup = true;
        return;
      }
      if (item.url) {
        if (item.query) {
          this.$router.push({ path: item.url, query: item.query }).catch(() => {});
        } else {
          this.$parent.goNav(item.url);
        }
      }
    },
    onchangemd(e) {
      let that = this;
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        formdata.append('file', item);
      });
      that.$parent.showLoading();
      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();
        that.$parent.getUserInfoShowLoding();
      });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0;
      let vip = that.$store.state.userInfo.vip * 1;
      that.vipLis.forEach((el, index) => {
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/common.css';

.lxb-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .lxb-img-pig,
  .lxb-img-coin {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.gjj-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .gjj-img-hands,
  .gjj-img-coin {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.wdjl-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .wdjl-img-frame,
  .wdjl-img-qr {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.txgl-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .txgl-img-frame,
  .txgl-img-detail {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.zkq-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .zkq-img-star,
  .zkq-img-percent {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.vip-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .vip-img-hat,
  .vip-img-dots {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.fxzq-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .fxzq-img-user,
  .fxzq-img-horn {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.fx-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .fx-img-circle,
  .fx-img-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }

  .fx-red-dot {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.2rem;
    height: 0.2rem;
    background: #ff3b30;
    border-radius: 50%;
  }
}

.dfgdb-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .dfgdb-img-shield,
  .dfgdb-img-check,
  .dfgdb-img-hands {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.grzl-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .grzl-img-user,
  .grzl-img-pencil {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.aqzx-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .aqzx-img-shield {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.yyxz-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .yyxz-img-e,
  .yyxz-img-n {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.cjwt-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .cjwt-img-frame,
  .cjwt-img-question {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.yjfk-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .yjfk-img-frame,
  .yjfk-img-detail {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.dlsb-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .dlsb-img-computer,
  .dlsb-img-frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.gywm-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .gywm-img-circle,
  .gywm-img-info {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.qhzh-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .qhzh-img-left,
  .qhzh-img-right {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

.tc-icon-wrap {
  position: relative;
  width: 0.65rem;
  height: 0.65rem;

  .tc-img-frame,
  .tc-img-arrow {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.65rem;
    height: 0.65rem;
  }
}

// 语言选择弹窗
.lang-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .lang-popup-content {
    width: 76%;
    // max-width: 6rem;
    background: #292A2C;
    border-radius: 0.2rem;
    padding: 0.5rem 0.4rem 0.8rem;
    position: relative;

    .lang-popup-title {
      text-align: center;
      color: #fff;
      font-size: 0.35rem;
      margin-bottom: 0.4rem;
    }

    .lang-popup-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.3rem 0;
      border-bottom: 1px solid #3a3a3a;
      color: #fff;
      font-size: 0.3rem;

      .lang-radio-active {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        background: #d1ae52;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .lang-popup-close {
      position: absolute;
      bottom: -1rem;
      left: 50%;
      transform: translateX(-50%);
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      border: 2px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.mine-header {
  padding: 0.3rem 0.3rem 0;
  background: url('/static/newImg/mine/style_7_topbg_yd.avif') no-repeat;
  background-size: 100% 100%;
  min-height: 3.5rem;
  display: flex;
  flex-direction: column;

  .mine-not-login {
    display: flex;
    align-items: center;
    justify-content: space-between;
    //padding: 0.5rem 0;
    margin-top: auto;

    .mine-not-login-text {
      display: flex;
      flex-direction: column;
      gap: 0.3rem;

      .mine-not-login-title {
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
      }

      .mine-not-login-btns {
        display: flex;
        gap: 0.2rem;

        .mine-not-login-btn {
          padding: 0.15rem 0.5rem;
          border-radius: 0.1rem;
          font-size: 0.3rem;
          text-align: center;
          cursor: pointer;
        }

        .mine-not-login-btn-login {
          background: #d1ae52;
          color: #000;
        }

        .mine-not-login-btn-register {
          background: transparent;
          color: #d1ae52;
          border: 1px solid #d1ae52;
        }
      }
    }

    .mine-not-login-gift {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .mine-header-icons {
    display: flex;
    justify-content: flex-end;
    gap: 0.3rem;
    // margin-bottom: 0.3rem;

    .mine-icon-item {
      img {
        width: 0.65rem;
        height: 0.65rem;
      }
    }
  }

  .mine-user-row {
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;

    .mine-avatar-box {
      position: relative;
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.25rem;
      flex-shrink: 0;

      img {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        border: 2px solid #DFB372;
      }

      .mine-avatar-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }

    .mine-user-info {
      flex: 1;
      min-width: 0;

      .mine-user-top {
        display: flex;
        align-items: center;
        margin-bottom: 0.08rem;

        .mine-username {
          color: #e3e3e3;
          font-size: 0.35rem;
          font-weight: 600;
        }

        .mine-copy-icon {
          width: 0.5rem;
          height: 0.5rem;
          margin-left: 0.1rem;
        }

        .mine-vip-icon {
          width: 0.4rem;
          height: 0.3rem;
          margin-left: 0.1rem;
        }

        .mine-switch-btn {
          color: #DFB372;
          font-size: 0.3rem;
          // margin-left: 0.05rem;
          display: flex;
          align-items: center;

          .mine-switch-icon {
            width: 0.3rem;
            height: 0.3rem;
            // margin-right: 0.05rem;
          }

          .mine-qh-icon {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.1rem;
            margin-left:0.2rem;
          }
        }
      }

      .mine-user-bottom {
        display: flex;
        align-items: center;
        padding-top: 0.2rem;

        .mine-id-label {
          color: #999;
          font-size: 0.32rem;
        }

        .mine-id-text {
          color: #fff;
          font-size: 0.32rem;
        }

        .mine-copy-icon-sm {
          width: 0.5rem;
          height: 0.5rem;
          margin-left: 0.08rem;
        }
      }
    }

    .header-actions {
      display: flex;
      gap: 0.3rem;
      flex-shrink: 0;

      .action-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 0.8rem;
          height: 0.8rem;
        }

        .action-icon-wrap {
          position: relative;

          img {
            width: 0.8rem;
            height: 0.8rem;
          }

          .action-badge {
            position: absolute;
            top: -0.1rem;
            right: -0.2rem;
            background: #ea4e3d;
            color: #fff;
            font-size: 0.18rem;
            padding: 0.02rem 0.08rem;
            border-radius: 0.1rem;
            white-space: nowrap;
          }
        }

        .action-text {
          color: #fff;
          font-size: 0.25rem;
          margin-top: 0.05rem;
        }
      }
    }
  }

  .mine-bottom-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    // padding-bottom: 0.3rem;

    .mine-balance-wrap {
      display: flex;
      align-items: center;

      .mine-balance-dot {
        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.1rem;
      }

      .mine-balance-num {
        color: #fff;
        font-size: 0.35rem;
        font-weight: 700;
        border-bottom: 1px solid #fff;
        padding-bottom: 0.05rem;
      }

      .mine-refresh-icon {
        width: 0.65rem;
        height: 0.65rem;
        margin-left: 0.15rem;
        transform: rotate(90deg);
      }
    }

    .mine-action-btns {
      display: flex;
      gap: 0.3rem;
      flex-shrink: 0;

      .mine-action-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1.5rem;

        img {
          width: 0.8rem;
          height: 0.8rem;
        }

        .mine-action-icon-box {
          position: relative;

          img {
            width: 0.8rem;
            height: 0.8rem;
          }

          .mine-action-badge {
            position: absolute;
            top: -0.1rem;
            right: -0.2rem;
            background: #ea4e3d;
            color: #fff;
            font-size: 0.25rem;
            padding: 0.02rem 0.08rem;
            border-radius: 0.1rem;
            white-space: nowrap;
          }
        }

        .mine-action-label {
          color: #999999;
          font-size: 0.35rem;
          margin-top: 0.05rem;
        }
      }
    }
  }
}

// 每日签到
.mine-checkin-box {
  margin: 0.3rem 0.3rem;
  padding: 0.25rem;
  background: #1a1a1a;
  // border: 1px solid #3B3C3D;
  border-radius: 0.2rem;

  .mine-checkin-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;

    .mine-checkin-title-wrap {
      .mine-checkin-title {
        display: block;
        color: #fff;
        font-size: 0.4rem;
        font-weight: 600;
        margin-bottom: 0.05rem;
      }

      .mine-checkin-subtitle {
        display: block;
        color: #999;
        font-size: 0.3rem;
        padding-top: 0.1rem;
      }
    }

    .mine-more-wrap {
      display: flex;
      align-items: center;
    }

    .mine-more-icon {
      width: 0.75rem;
      height: 0.75rem;
      margin-right: -0.1rem;
    }

    .mine-checkin-more {
      display: flex;
      align-items: center;
      background: #DFB372;
      border-radius: 0 0.5rem 0.5rem 0;
      padding: 0.08rem 0.2rem;
      color: #703904;
      font-size: 0.3rem;
      font-weight: 400;
    }
  }

  .mine-checkin-scroll {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 0.15rem;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 0.3rem 0 0 0;
    &::-webkit-scrollbar {
      display: none;
    }

    .mine-checkin-card {
      flex-shrink: 0 !important;
      width: 1.35rem !important;
      padding: 0.15rem 0.1rem;
      background: #1a1a1a;
      border: 1px solid #3B3C3D;
      border-radius: 0.15rem;
      text-align: center;
      overflow: visible;
      box-sizing: border-box;
      position: relative;

      &.mine-checkin-card-first {
        border-color: #04be02;
      }

      .mine-checkin-extra {
        position: absolute;
        top: -0.35rem;
        left: 50%;
        transform: translateX(-50%);
        background: #04be02;
        color: #fff;
        font-size: 0.25rem;
        padding: 0.02rem 0.1rem;
        border-radius: 0.08rem;
        white-space: nowrap;
      }

      .mine-checkin-amount {
        color: #ffaa09;
        font-size: 0.35rem;
        font-weight: 600;
        margin-bottom: 0.1rem;
      }

      .mine-checkin-img {
        img {
          width: 0.65rem;
          height: 0.65rem;
        }
      }

      .mine-checkin-label {
        color: #fff;
        font-size: 0.3rem;
        margin-top: 0.08rem;
        white-space: nowrap;

        &.mine-checkin-btn {
          background: #04be02;
          border-radius: 0.25rem;
          padding: 0.05rem 0;
          margin-top: 0.08rem;
        }

        &.mine-checkin-label-claimed {
          color: #666;
        }
      }
    }
  }
}

// 绑定钱包横幅
.bind-banner {
  margin: 0 0.3rem 0.3rem;
  padding: 0.35rem 0.25rem 0.35rem 0;
  background: #1a1a1a;
  // border: 1px solid #3B3C3D;
  border-radius: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .bind-text {
    display: flex;
    align-items: center;
    gap: 0.1rem;

    .bind-no-logo {
      width: 0.2rem;
      height: 0.4rem;
      flex-shrink: 0;
      margin-right:0.2rem;
    }

    .bind-no {
      color: #fff;
      font-size: 0.28rem;
    }

    .bind-amount {
      color: #ffaa09;
      font-size: 0.35rem;
      font-weight: 700;
    }

    .bind-prize {
      color: #fff;
      font-size: 0.28rem;
    }
  }

  .bind-btns {
    display: flex;
    align-items: center;
    gap: 0.15rem;

    .bind-btn {
      background: #DFB372;
      color: #000;
      font-size: 0.28rem;
      padding: 0.06rem 0.25rem;
      border-radius: 0.1rem;
      font-weight: 400;
    }

    .bind-refresh {
      width: 0.55rem;
      height: 0.55rem;
    }
  }
}

// 快捷功能
.quick-functions {
  margin: 0 0.3rem;
  padding: 0.3rem 0.3rem;
  //padding-bottom: 1.5rem;
  background: #1a1a1a;
  margin-bottom: 2.5rem;
  margin-top: 0.5rem;
  .section-title {
    color: #fff;
    font-size: 0.35rem;
    font-weight: 600;
    margin-bottom: 0.3rem;
  }

  .func-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.3rem 0.1rem;

    .func-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .func-icon-wrap {
        position: relative;
        width: 0.8rem;
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.1rem;

        img {
          width: 0.6rem;
          height: 0.6rem;
        }

        .func-badge {
          position: absolute;
          top: -0.1rem;
          right: -0.45rem;
          background: #4CAF50;
          color: #fff;
          font-size: 0.25rem;
          padding: 0.02rem 0.08rem;
          border-radius: 0.1rem;
        }
      }

      .func-name {
        color: #999;
        font-size: 0.32rem;
        text-align: center;

        &.func-name-br {
          line-height: 1.2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue